import { useTranslation } from '@mint-lib/i18n';
import { Bot } from '@mint-lib/icons';
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  DrawerPortal,
  DrawerRoot,
  DrawerTitle,
  DrawerTrigger,
} from '@mint-lib/tw-components';

import { TabButton } from '../TabButton.jsx';

export const SuggestionsDrawer = () => {
  const { t } = useTranslation('@myn/planning_v2');

  return (
    <Drawer>
      <DrawerTrigger asChild>
        <TabButton
          Icon={Bot}
          tooltip={t('Suggestions')}
          aria-label="Open suggestions drawer"
          disabled
        />
      </DrawerTrigger>
      <DrawerPortal>
        <DrawerOverlay />
        <DrawerRoot>
          <DrawerHeader>
            <DrawerTitle>{t('Suggestions')}</DrawerTitle>
          </DrawerHeader>
          <DrawerContent>{t('Suggestions')}</DrawerContent>
        </DrawerRoot>
      </DrawerPortal>
    </Drawer>
  );
};
